import axios from 'axios'
import { ref, toRef, computed } from 'vue'
import { useAuth } from './useAuth'
import { useArtistRegister } from './useArtistRegister'
import { useVenueRegister } from './useVenueRegister'
import useNotification from '@/composables/useNotification.js'
import useCookies from '@/composables/utils/useCookies.js'

const URLS = {
    icons: {
        instagram: '/images/icons/instagram-negative.svg',
        facebook: '/images/icons/facebook-negative.svg',
        google: '/images/icons/google-negative.svg',
        hoveredUnselect: '/images/icons/hoveredUnselect.svg',
        hoveredSelect: '/images/icons/calendar/hoveredSelect.svg',

        socialLinks: {
            instagram: '/images/icons/instagram-grey.svg',
            facebook: '/images/icons/facebook-grey.svg',
            tiktok: '/images/icons/tiktok-grey.svg',
            youtube: '/images/icons/youtube-grey.svg',
            spotify: '/images/icons/spotify-grey.svg',
            mixcloud: '/images/icons/mix-grey.svg'
        }
    },
    redirect: {
        google: '/login/google',
        instagram: '/login/instagrambasic',
        facebook: '/login/facebook',
        tiktok: '/login/tiktok',
        youtube: '/login/youtube',
        spotify: '/login/spotify',
        mixcloud: '/login/mixcloud'
    },
    xhr: {
        mutate: {
            social: '/api/profile/social/link'
        }
    }
}

const artistSocialLinks = ref([
    /* TODO: fix social providers auth and uncomment below **/
    // {
    //     id: null,
    //     field: 'Instagram',
    //     active: false,
    //     hovered: false,
    //     href: URLS.redirect.instagram,
    //     icon: URLS.icons.socialLinks.instagram
    // },
    // {
    //     id: null,
    //     field: 'Facebook',
    //     active: false,
    //     hovered: false,
    //     href: URLS.redirect.facebook,
    //     icon: URLS.icons.socialLinks.facebook
    // },
    {
        id: null,
        field: 'Tiktok',
        active: false,
        hovered: false,
        href: URLS.redirect.tiktok,
        icon: URLS.icons.socialLinks.tiktok
    },
    {
        id: null,
        field: 'Youtube',
        active: false,
        hovered: false,
        href: URLS.redirect.youtube,
        icon: URLS.icons.socialLinks.youtube
    },
    // {
    //     id: null,
    //     field: 'Spotify',
    //     active: false,
    //     hovered: false,
    //     href: URLS.redirect.spotify,
    //     icon: URLS.icons.socialLinks.spotify
    // },
    {
        id: null,
        field: 'Mixcloud',
        active: false,
        hovered: false,
        href: URLS.redirect.mixcloud,
        icon: URLS.icons.socialLinks.mixcloud
    }
])
const venueSocialLinks = ref([
    /* TODO: fix social providers auth and uncomment below **/
    // {
    //     id: null,
    //     field: 'Instagram',
    //     active: false,
    //     hovered: false,
    //     href: URLS.redirect.instagram,
    //     icon: URLS.icons.socialLinks.instagram
    // },
    // {
    //     id: null,
    //     field: 'Facebook',
    //     active: false,
    //     hovered: false,
    //     href: URLS.redirect.facebook,
    //     icon: URLS.icons.socialLinks.facebook
    // },
    {
        id: null,
        field: 'Tiktok',
        active: false,
        hovered: false,
        href: URLS.redirect.tiktok,
        icon: URLS.icons.socialLinks.tiktok
    },
    {
        id: null,
        field: 'Youtube',
        active: false,
        hovered: false,
        href: URLS.redirect.youtube,
        icon: URLS.icons.socialLinks.youtube
    }
])
export const useAuthSocial = (props) => {
    const role = toRef(props, 'role')
    const { load, mode, userValues } = useAuth()
    const { handleRegisterArtist, allArtistRequiredFieldsFilled } = useArtistRegister()
    const { handleRegisterVenue, allVenueRequiredFieldsFilled } = useVenueRegister()
    const { notification } = useNotification()
    const { setCookie, deleteCookie } = useCookies()

    const socialLogins = ref([
        /* TODO: fix social providers auth and uncomment below **/
        // {
        //     name: 'Instagram',
        //     icon: URLS.icons.instagram,
        //     href: URLS.redirect.instagram
        // },
        // {
        //     name: 'Facebook',
        //     icon: URLS.icons.facebook,
        //     href: URLS.redirect.facebook
        // },
        {
            name: 'Google',
            icon: URLS.icons.google,
            href: URLS.redirect.google
        }
    ])

    const socials = computed(() => {
        switch (role.value) {
            case 'user':
                return socialLogins.value
            case 'venue':
                return venueSocialLinks.value
            case 'artist':
                return artistSocialLinks.value
            default:
                return []
        }
    })
    const socialBtnClass = computed(() => (btn) => {
        let _class = {}

        if (btn.active) {
            _class['social-btn-active'] = true
        } else {
            _class['social-btn-inactive'] = true
        }

        if (btn.hovered) {
            _class['social-btn-hovered'] = true
        }

        return _class
    })

    ;(() => {
        switch (role.value) {
            case 'venue':
                _populateSocialValues(venueSocialLinks)
                break
            case 'artist':
                _populateSocialValues(artistSocialLinks)
                break
            default:
                break
        }
    })()

    async function handleSocialLinkClick(social, { mode, role }) {
        if (social.active) {
            social.active = false
            await _deleteSocialLink([social.id])
            userValues.value.socials = userValues.value.socials.filter((s) => s.type !== social.field)
        } else {
            return await handleRedirectSocial(social, { mode, role })
        }
    }
    async function handleRedirectSocial(social, { mode, role }) {
        _handleSaveToLocalStorageAndCookie(mode, role)

        if (mode === 'auth') {
            window.location.href = social.href
        } else {
            if (role === 'venue' && !allVenueRequiredFieldsFilled.value) {
                notification('error', 'Missing venue required fields.')
            } else if (role === 'artist' && !allArtistRequiredFieldsFilled.value) {
                notification('error', 'Missing artist required fields.')
            } else if (role === 'artist' && allArtistRequiredFieldsFilled.value) {
                social.active = true
                await handleRegisterArtist(false)
                window.location.href = social.href
            } else if (role === 'venue' && allVenueRequiredFieldsFilled.value) {
                social.active = true
                await handleRegisterVenue(false)
                window.location.href = social.href
            }
        }
    }
    function handleSocialHover(btn) {
        btn.hovered = !btn.hovered
    }

    function _populateSocialValues(links) {
        if (!userValues.value.socials.length) return

        userValues.value.socials.forEach(({ id, type }) => {
            links.value.forEach((s) => {
                if (type === s.field) {
                    s.active = true
                    s.id = id
                }
            })
        })
    }
    async function _deleteSocialLink(data) {
        data = _prepDeleteSocialData(data)
        try {
            load.value = true
            return await axios.delete(`${URLS.xhr.mutate.social}/${data}/${userValues.value.id}`)
        } catch (error) {
            notification('error', 'Could not delete social link')
        } finally {
            load.value = false
        }
    }
    function _prepDeleteSocialData(data) {
        return window.btoa(JSON.stringify(data))
    }
    function _handleSaveToLocalStorageAndCookie(socialMode, role) {
        localStorage.removeItem('auth-modal')
        localStorage.removeItem('role')
        localStorage.removeItem('register-mode')

        if (socialMode === 'auth') {
            try {
                const params = new URL(window.location.toString()).searchParams
                const affiliate = JSON.parse(params.get('affiliate'))

                if (affiliate) localStorage.setItem('affiliate', affiliate.toString())
            } catch (error) {
                console.error(error)
            }

            localStorage.setItem('auth-modal', 'auth')
        } else {
            localStorage.setItem('auth-modal', 'link')
        }
        localStorage.setItem('role', role)
        localStorage.setItem('register-mode', mode.value.toString())
        deleteCookie('link-role')
        setCookie({ name: 'link-role', value: role, expireMinutes: 2 })
    }

    return {
        URLS,
        socials,
        socialBtnClass,
        socialLogins,
        artistSocialLinks,
        venueSocialLinks,
        handleRedirectSocial,
        handleSocialLinkClick,
        handleSocialHover
    }
}
